import { styled } from 'styled-components'

import { Card } from '@/buyer-portal/components/layouts/CardLayout/card/ui'

import { UnAuthWarning } from './UnAuthWarning'

// Card treatment of UnAuthWarning for the LDP redesign (V2). Reads correctly
// both on the grey desktop body and within the white card stack at
// mobile/tablet widths, where a bare UnAuthWarning has no container.
const Body = styled(Card)`
  padding: 2rem 1.5rem;
`

export const UnAuthWarningCard = ({
  className,
  ...props
}: React.ComponentProps<typeof UnAuthWarning>) => (
  <Body className={className} data-testid="UnAuthWarningCard">
    <UnAuthWarning {...props} />
  </Body>
)
